declare global { interface Window { __ROVERO_ROLE_SANDBOX__?: boolean } }
export const isRoleSandbox = () => typeof window !== "undefined" && window.__ROVERO_ROLE_SANDBOX__ === true;
export const isDemoMode = () => import.meta.env.VITE_IS_DEMO === "true" || isRoleSandbox();
